export default function ({ route, redirect, error }) {
  // Kiểm tra nếu route không tồn tại (404)
  if (route.name === null || route.name === undefined) {
    // Redirect về trang chủ thay vì hiển thị error page
    return redirect('/')
  }
}